import { filter, ignoreElements, tap } from "rxjs/operators";
import { IdEventSoundCore } from "../../../utils/sound/IdEventSoundCore";
import { utilSound } from "../../../utils/sound/utilSound";
import { utilBuildings } from "../../../utils/utilBuildings";
import { TypeActionBuildings } from "../../player-base/buildings/actionBuildings";
export var epicSoundsBuildingCelebration = function (action$) {
    return action$.pipe(filter(function (action) {
        return action.type === TypeActionBuildings.Select &&
            utilBuildings.hasFinishedConstruction(action.building);
    }), tap(function () { return utilSound.event(IdEventSoundCore.BuildingCelebration); }), ignoreElements());
};



//////////////////
// WEBPACK FOOTER
// ./src/features/sound/epics/epicSoundsBuildingCelebration.ts
// module id = 2400
// module chunks = 3